import { httpClient, baseUrl } from 'src/pages/admin/providers/AppDataProvider';
import type { TurnkeyAddressSearchResponse } from './turnkeyAddressSearch.types';

const BASE = `${baseUrl}/turnkey-address-search`;

function buildQuery(params: Record<string, any>) {
    const sp = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null || value === '') return;

        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item === undefined || item === null || item === '') return;
                sp.append(key, String(item));
            });
            return;
        }

        sp.set(key, String(value));
    });

    const qs = sp.toString();
    return qs ? `?${qs}` : '';
}

async function apiGet<T>(path: string, params: Record<string, any> = {}) {
    const url = `${path}${buildQuery(params)}`;
    const { json } = await httpClient(url, { method: 'GET' });
    return json as T;
}

export function searchTurnkeyAddress(keywords: string[]) {
    return apiGet<TurnkeyAddressSearchResponse>(BASE, {
        keywords,
    });
}
